<template>
  <div class="horizontal-bar-outer">
    <div class="horizontal-bar-values">
      <DollarValue :value="data[0]!.value || 0" fontSize="2.1875rem" :privacy="true" />
      <DollarValue
        :value="data[1]!.value || 0"
        fontSize="1.25rem"
        :color="colorVidacorp"
        lineHeight="1.25rem"
        :style="{visibility: data[1]!.value > 0 ? 'visible' : 'hidden' }"
      >
        <template #caption>
          <div class="caption"><span>Opportunity</span></div></template
        >
      </DollarValue>
    </div>
    <div class="horizontal-bars">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="bar"
        :style="{
          width: (item.value! / totalValue) * 100 + '%',
          backgroundColor: index === 0 ? colors.primary : colors.secondary
        }"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DollarValue from '@/components/common/DollarValue.vue'
import type { PropType } from 'vue'
import { useThemeStore } from '@/stores'
import type { IChartDataItem } from '@/components/common/common'

const themeStore = useThemeStore()
const { colorVidacorp } = themeStore.themeColors

const props = defineProps({
  data: {
    type: Array as PropType<IChartDataItem[]>,
    required: true,
    validator: (value: IChartDataItem[]) => {
      if (value.length > 2) {
        console.error('The "data" prop can contain at most 2 items.')
        return false
      }
      return true
    }
  },
  colors: {
    type: Object,
    default: () => ({
      primary: '#939393',
      secondary: '#565656',
      tertiary: '#414141'
    })
  }
})

// Compute the total value from the data
const totalValue = computed(() => props.data.reduce((sum, item) => sum + (item.value || 0), 0))
</script>

<style scoped>
.horizontal-bar-outer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: 100%;
  min-width: 13.75rem;
}

.horizontal-bar-values {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  width: 100%;
}

.horizontal-bars {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 90%;
  gap: 0.3125rem;
  margin-bottom: 0.625rem;
}

.horizontal-bars .bar {
  height: 0.1875rem;
  border-radius: 0.3125rem;
}

.caption {
  font-size: var(--font-size-small);
  display: flex;
  align-items: center;
  gap: 0.3125rem;
}
</style>
